module.exports = __webpack_public_path__ + "static/img/jifen.8099a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/jifen.png
// module id = WSV0
// module chunks = 36